<template>
  <div class="raise-now">
    <iframe src="https://donate.raisenow.io/dgvgh" class="raise-now__iframe" />
  </div>
</template>

<style lang="scss" scoped>
@use "~/assets/sass/tools";

.raise-now {
  @include tools.page-grid-columns;

  &__iframe {
    border: none;
    width: 100%;
    max-width: 600px;
    height: 3000px;
  }
}
</style>
